export const CURRENCY_SYMBOL_DATA_MAP = {
  EUR: { symbol: '€', isPrefix: false },
  USD: { symbol: '$', isPrefix: true },
  GBP: { symbol: '£', isPrefix: true },
  AUD: { symbol: 'A $', isPrefix: true },
  CHF: { symbol: 'CHF ', isPrefix: true },
  HKD: { symbol: 'HK $', isPrefix: true },
  SGD: { symbol: 'S $', isPrefix: true },
  JPY: { symbol: '¥', isPrefix: true },
  DKK: { symbol: 'DKK ', isPrefix: true },
  CAD: { symbol: 'C $', isPrefix: true },
  SEK: { symbol: 'SEK ', isPrefix: true },
} as const;
